/* eslint-disable import/no-default-export */
// eslint-disable-next-line no-restricted-imports
import type { Action } from '@trello/redux';
// eslint-disable-next-line no-restricted-imports
import { actionCreator, createReducer } from '@trello/redux';

const SET_MEMBER = Symbol('models/SET_MEMBER');

type SetMemberAction = Action<typeof SET_MEMBER, UserIdPayload>;

interface UserIdPayload {
  idMe: string | null;
}

export interface SessionState {
  idMe: string;
  token?: string;
}
// Reducer
const initialState: SessionState = {
  idMe: '',
};

export default createReducer(initialState, {
  [SET_MEMBER](state: SessionState, { payload }: SetMemberAction) {
    const { idMe } = payload;
    if (!idMe) {
      return state;
    }

    return { ...state, idMe };
  },
});

export const setMember = actionCreator<SetMemberAction>(SET_MEMBER);
